import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ProfileHelpModules, ProfileModules } from 'globals/constants'
import { IAppStore } from 'store/app.store'

export interface ProfileModulesTypes {
  openedProfileModule: ProfileModules | null
  openedProfileHelpModule: { key: ProfileHelpModules; options: { Title: string; Id?: string } } | null
  isChangeMembershipDialogOpen: boolean
  isOldPaidMembersDialogOpen: boolean
  subAccountAddedCount: number
}

const initialState: ProfileModulesTypes = {
  openedProfileModule: null,
  openedProfileHelpModule: null,
  isChangeMembershipDialogOpen: false,
  isOldPaidMembersDialogOpen: false,
  subAccountAddedCount: 0,
}

export const ProfileModulesSlice = createSlice({
  name: 'ProfileModules',
  initialState: initialState,
  reducers: {
    setOpenedProfileModule: (state: ProfileModulesTypes, action) => {
      state.openedProfileModule = action.payload
    },
    setOpenedProfileHelpModule: (
      state: ProfileModulesTypes,
      action: PayloadAction<{ key: ProfileHelpModules; options: { Title: string; Id?: string } }>
    ) => {
      state.openedProfileHelpModule = action.payload
    },
    closeProfileHelpModule: (state: ProfileModulesTypes) => {
      state.openedProfileHelpModule = null
    },
    openChangeMembershipDialog: (state: ProfileModulesTypes) => {
      state.isChangeMembershipDialogOpen = true
    },
    closeChangeMembershipDialog: (state: ProfileModulesTypes) => {
      state.isChangeMembershipDialogOpen = false
    },
    openOldPaidMembersSubscriptionDialog: (state: ProfileModulesTypes) => {
      state.isOldPaidMembersDialogOpen = true
    },
    closeOldPaidMembersSubscriptionDialog: (state: ProfileModulesTypes) => {
      state.isOldPaidMembersDialogOpen = false
    },
    setSubAccountAddedCount: (state: ProfileModulesTypes) => {
      state.subAccountAddedCount += 1
    },
  },
})

export const {
  setOpenedProfileModule,
  setOpenedProfileHelpModule,
  closeProfileHelpModule,
  openChangeMembershipDialog,
  closeChangeMembershipDialog,
  openOldPaidMembersSubscriptionDialog,
  closeOldPaidMembersSubscriptionDialog,
  setSubAccountAddedCount,
} = ProfileModulesSlice.actions
export const ProfileModulesliceSelector = (appState: IAppStore): ProfileModulesTypes => appState.ProfileModules
